import React from "react";
import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Tab,
  Tabs,
  TextField,
  Stack,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import TabPanel from "../../components/TabPanel";
import {
  getTransactionDocpurchaseOrderdetails1,
  getTransactionDocPurchaseItemDetails,
  getTransactionDocShippingaddress,
  getTransactionDoBillingaddress,
  getTransactionPurchaseOrder,
} from "../../api/transaction-type";
import useSnackbar from "../../hooks/useSnackbar";
import { useSelector } from "react-redux";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import {
  invoiceSupportCasesTable,
  purchaseOrderApproverList,
  purchaseOrderItemsExpensesTable,
  purchaseOrderItemsTable,
  purchaseOrderPhilippinesTable,
  purchaseOrderRelatedRecordApprovals,
  purchaseOrderRelatedRecordReceiptsBillsTable,
  purchaseOrderRelatedRecordTransformation,
  purchaseRelationshipContactTable,
} from "../../config/grid-column-defs";
import PurchaseOrderCommunication from "./purchase-order/communication";
import PurchaseOrderSystemInformation from "./purchase-order/system-information";
import PurchaseOrderCustom from "./purchase-order/custom";
import { CustomCheckBox } from "../../components/CheckboxComp";
import PurchaseOrderItems from "./purchase-order/items";
import PurchaseOrderBilling from "./purchase-order/billing";
import PurchaseOrderEft from "./purchase-order/eft";
export default function TransactionTypePurchaseOrder() {
  const snackbar = useSnackbar();
  const [loading, setLoading] = useState(false);
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [historytabIndex, setHistoryTabIndex] = useState(0);
  const [linkingdocumentno, setlinkingdocumentno] = useState("");
  const [shipping, setShipping] = useState([]);
  const [address, setAddress] = useState([]);

  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [subtabIndex, setSubTabIndex] = useState(0);
  const [tabIndexRelationship, setTabIndexRelationship] = useState(0);
  const [tabIndexRelatedRecord, setTabIndexRelatedRecord] = useState(0);
  const [tabIndexApproveList, setTabIndexApproveList] = useState(0);

  /*----------------End Tabs-----------------*/
useEffect(() => {
    if (user.token) {
      getTransactionDocDetailsData();
    }
  }, []);

  async function getTransactionDocDetailsData() {
    setLoading(true);
    try {
      const { data } = await getTransactionPurchaseOrder(user.token, {
        tranid: params.docNo,
      });
      setRowData(data.data.details[0]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  
  async function getItemsTab() {
    try {
      const { data } = await getTransactionDocPurchaseItemDetails(user.token, {
        id: params.docNo,
        limit: "",
      });
      setlinkingdocumentno(data.data.linkingdocumentno);
      // return {
      //   rows: data.data.purchaseorderdetails,
      //   total: data.data.Detailstotal,
      //   error: false,
      // };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  }
  const Shippingaddress = async () => {
    try {
      const { data } = await getTransactionDocShippingaddress(user.token, {
        id: params.docNo,
        limit: "",
      });
      setShipping(data.data.data);
      setlinkingdocumentno(data.data.linkingdocumentno);
      // return {
      //   rows: data.data.purchaseorderdetails,
      //   total: data.data.Detailstotal,
      //   error: false,
      // };
    } catch (error) {
      console.log(error);
      setShipping([]);

      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  };

  const Billingaddress = async () => {
    try {
      const { data } = await getTransactionDoBillingaddress(user.token, {
        id: params.docNo,
        limit: "",
      });
      setAddress(data.data.data);
      // return {
      //   rows: data.data.purchaseorderdetails,
      //   total: data.data.Detailstotal,
      //   error: false,
      // };
    } catch (error) {
      console.log(error);
      setAddress([]);

      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  };

  
    return loading ? (
      <>
         <Typography component="h4" fontWeight={500} className="pageTitle">
        Purchase Order
      </Typography>

        <Box className="viewBox">
          <Box
            className="headerItems"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            pb={2}
          >
            <Typography
              component="h5"
              fontWeight={500}
              className="pageHeading1"
            ></Typography>
            <Link to={"/transaction-type/" + params.slug}>
              <Button size="small"  className="backBtn">
                Go Back
              </Button>
            </Link>
          </Box>
          <Box className="viewDetilsBox">
                   <Grid container className="mb-2">
                     <Grid item xs={12}>
                       <div
                         style={{
                           width: "100%",
                           display: "flex",
                           justifyContent: "center",
                           alignItems: "center",
                         }}
                       >
                         <CircularProgress></CircularProgress>
                       </div>
                     </Grid>
                   </Grid>
                 </Box>
               </Box>
               <Box className="viewBox">
                 <Box
                   className="headerItems"
                   display="flex"
                   alignItems="center"
                   justifyContent="space-between"
                   pb={2}
                 >
                   <Typography component="h5" fontWeight={500} className="pageHeading1">
                     Classification
                   </Typography>
                 </Box>
                 <Box className="viewDetilsBox">
                   <Grid container className="mb-2">
                     <Grid item xs={12}>
                       <div
                         style={{
                           width: "100%",
                           display: "flex",
                           justifyContent: "center",
                           alignItems: "center",
                         }}
                       >
                         <CircularProgress></CircularProgress>
                       </div>
                     </Grid>
                   </Grid>
                 </Box>
               </Box>
               <Box className="viewBox">
                 <Box
                   className="headerItems"
                   display="flex"
                   alignItems="center"
                   justifyContent="space-between"
                   pb={2}
                 >
                   <Typography component="h5" fontWeight={500} className="pageHeading1">
                    
                   </Typography>
                 </Box>
                 <Box className="viewDetilsBox">
                   <Grid container className="mb-2">
                     <Grid item xs={12}>
                       <div
                         style={{
                           width: "100%",
                           display: "flex",
                           justifyContent: "center",
                           alignItems: "center",
                         }}
                       >
                         <CircularProgress></CircularProgress>
                       </div>
                     </Grid>
                   </Grid>
                 </Box>
               </Box>
      </>
    ) : (
    <>
      {/*Primary Information*/}
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Purchase Order
      </Typography>
      <Typography component="h5" style={{ marginBottom: 5 }}>
        <span className="para-no"style={{ marginRight: 3 }}><strong>{rowData?.transaction_id}</strong>{" "}{rowData.displayname}</span>
        <Button className="blue-button" size="small">
        {rowData?.status}
        </Button>
      </Typography>

      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <>
            {/* {rowData?.map((el, i) => ( */}
              <Grid container className="mb-2" >
                <Grid item xs={12} sm={6} md={8}>
                  <Grid container className="mb-2">
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">PO #</p>
                      <p className="tFormName">{rowData.transaction_id}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">APPROVAL STATUS</p>
                      <p className="tFormName">{rowData.approval_status}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">VENDOR</p>
                      <p className="tFormName">{rowData.vendor_name}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">PURCHASE ORDER APPROVAL STATUS</p>
                      <p className="tFormName">{rowData.purchase_order_approval_status}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">VENDOR REQUEST LINK(2)</p>
                   {/* <Link to={rowData?.vendor_request_link}>  <p className="tFormName">{"CLICK HERE FOR NEW VENDOR REQUEST"}</p></Link>  */}
                   <p className="tFormName" style={{color:"#009de2"}}>{"CLICK HERE FOR NEW VENDOR REQUEST"}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">NEXT APPROVER</p>
                      <p className="tFormName">{rowData.next_approver}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">PC/PROJECT</p>
                      <p className="tFormName">{rowData.pc_project}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">REJECT/CLOSE REASON</p>
                      <p className="tFormName">{rowData.reject_reason}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">CREATED BY</p>
                      <p className="tFormName">{rowData.created_by}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">REJECTING EMPLOYEE</p>
                      <p className="tFormName">{rowData.reject_employee}</p>
                    </Grid>
                
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">Date</p>
                      <p className="tFormName">{rowData.date}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">CORPORATE APPROVAL</p>
                      <p className="tFormName">{rowData.corporate_approver}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">RECEIVE BY</p>
                      <p className="tFormName">{rowData.received_by}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">PC/PROJECT DIRECTOR</p>
                      <p className="tFormName">{rowData.pc_project_director}</p>
                    </Grid>
        
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">MEMO</p>
                      <p className="tFormName">{rowData.memo}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">PC/PROJECT VP</p>
                      <p className="tFormName">{rowData.pc_project_vp}</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">PURCHASE REASON</p>
                      <p className="tFormName">{rowData.purch_reason}</p>
                    </Grid>
                   
                    <Grid item xs={12} sm={6} md={6} className="m-b-10">
                      <p className="tFormlabel">SHIP TO ADDRESS</p>
                      <p className="tFormName">{rowData.pc_shipto_address}</p>
                    </Grid>
                     <Grid item xs={12} sm={6} md={6} className="m-b-10">
                                         <p className="tFormlabel checkAndTextAlign">
                                           {rowData.accrual_related === "false" ||
                                           rowData.accrual_related === null ||
                                           rowData.accrual_related === "" ? (
                                             <>
                                               <FormGroup>
                                                 <FormControlLabel
                                                   control={<Checkbox disabled />}
                                                   label=""
                                                 />
                                               </FormGroup>
                                              ACCRUAL RELATED
                                             </>
                                           ) : (
                                             <>
                                               <FormGroup>
                                                 <FormControlLabel
                                                   control={<Checkbox disabled checked />}
                                                   label=""
                                                 />
                                               </FormGroup>
                                              ACCRUAL RELATED
                                             </>
                                           )}
                                         </p>
                                   </Grid>
                  </Grid>
                </Grid>
                {/* -----------Summary Box------------- */}
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="viewBox">
                    <Box
                      className="headerItemsSB"
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      pb={2}
                    >
                      <Typography
                        component="h5"
                        fontWeight={500}
                        className="pageHeading1"
                      >
                        Summary
                      </Typography>
                    </Box>
                    <Box className="viewDetilsBox1">
                      <Grid container className="mb-2">
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormlabel">TOTAL</p>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} className="m-b-10">
                          <p className="tFormtotal">{rowData.total_amount}</p>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            {/* ))} */}
          </>
        </Box>
      </Box>
      <Box>
           {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData?.map((el, i) => ( */}
            <Grid container className="mb-2" >
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">Subsidiary</p>
                <p className="tFormName">{rowData.subsidiary}</p>
              </Grid>

              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">Department</p>
                <p className="tFormName">{rowData.department}</p>
              </Grid>

              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">SERVICE LINE</p>
                <p className="tFormName">{rowData.service_line}</p>
              </Grid>
              <Grid item xs={12} sm={12} md={12} className="m-b-10">
                <p className="tFormlabel">LOCATION</p>
                <p className="tFormName">{rowData.location}</p>
              </Grid>
              <Grid item xs={12} sm={12} md={12} className="m-b-10">
                <p className="tFormlabel">ORIGINAL INVOICE DATE</p>
                <p className="tFormName">{rowData.original_invoice_date}</p>
              </Grid>
            </Grid>
          {/* ))} */}
        </Box>
      </Box>
        {/* -----------TABS------------- */}
        <Box
          className="viewBox "
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg"
          >
            <Tab label="Items" />
            <Tab label="Billing" />
            <Tab label="Relationships" />
            <Tab label="Communication" />
            <Tab label="Related Records" />
            <Tab label="System Information" />
            <Tab label="Custom" />
            <Tab label="EFT" />
            <Tab label="J.P.Morgan" />
          </Tabs>
          {/*------------Items------------*/}
          <TabPanel value={tabIndex} index={0}>
          {tabIndex === 0 && <PurchaseOrderItems tabIndexp={tabIndex}/>}
          </TabPanel>
          {/*------------BILLING------------*/}
          <TabPanel value={tabIndex} index={1}>
           {tabIndex===1 && <PurchaseOrderBilling/>}
            
          </TabPanel>
          {/*------------Relationships------------*/}
          <TabPanel value={tabIndex} index={2}>
            <Box className="viewDetilsBox">
              <Tabs
                value={tabIndexRelationship}
                onChange={(e, nv) => {
                  setTabIndexRelationship(nv);
                }}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
                className="tabs-sub-bkg"
              >
                <Tab label="Contacts" />
              </Tabs>
              <TabPanel value={tabIndexRelationship} index={0}>
                <Box>
                  <Grid container spacing={1} style={{marginTop:"4px"}}>
                    <Grid item xs={12} sm={3} className="m-b-10">
                      <TextField
                        id="outlined-basic"
                        label="Contact"
                        variant="outlined"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} className="m-b-10">
                      <FormControl size="small" fullWidth>
                        <InputLabel id="demo-select-small-label">
                          ROLE
                        </InputLabel>
                        <Select
                          labelId="demo-select-small-label"
                          id="demo-select-small"
                          value=""
                          label="Role"
                          //onChange={handleChange}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3} className="m-b-10">
                      <FormControl size="small" fullWidth>
                        <InputLabel id="demo-select-small-label">
                          VIEW
                        </InputLabel>
                        <Select
                          labelId="demo-select-small-label"
                          id="demo-select-small"
                          value=""
                          label="View"
                          //onChange={handleChange}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Box
                    sx={{
                      backgroundColor: "#bbd9e8",
                      p: 1,
                    }}
                  >
                    <Stack spacing={2} direction="row">
                      <Button className="blue-button">New Contact</Button>
                      <Button className="blue-button">Customize View</Button>
                    </Stack>
                  </Box>
                  <AgGridPaginatedTable
                    //getTableRows={getRelationshipContactTable}
                    columns={purchaseRelationshipContactTable}
                    refreshCounter={0}
                  />
                </Box>
              </TabPanel>
            </Box>
          </TabPanel>
          {/*------------Communication------------*/}
          <TabPanel value={tabIndex} index={3}>
          {tabIndex === 3 &&  <PurchaseOrderCommunication />}
          </TabPanel>
          {/*------------RELATED RECORDS ------------*/}
          <TabPanel value={tabIndex} index={4}>
            <Box p={1}>
              <Tabs
                value={tabIndexRelatedRecord}
                // onChange={handleChange}
                onChange={(e, nv) => {
                  setTabIndexRelatedRecord(nv);
                }}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
                className="tabs-sub-bkg"
              >
                <Tab label="Receipts & Bills" />
                <Tab label="Approvals" />
                <Tab label="Support cases" />
                <Tab label="Transformation" />
              </Tabs>
              <Button className="blue-button" style={{margin:"2px"}}>Print</Button>
              <TabPanel value={tabIndexRelatedRecord} index={0}>
                <AgGridPaginatedTable
                  // getTableRows={getTransactionShippingAddressData}
                  columns={purchaseOrderRelatedRecordReceiptsBillsTable}
                  refreshCounter={0}
                />
              </TabPanel>
              <TabPanel value={tabIndexRelatedRecord} index={1}>
                <AgGridPaginatedTable
                  // getTableRows={getTransactionShippingAddressData}
                  columns={purchaseOrderRelatedRecordApprovals}
                  refreshCounter={0}
                />
              </TabPanel>
              <TabPanel value={tabIndexRelatedRecord} index={2}>
              <Box className="viewDetilsBox">
              <Grid container spacing={2} py={2}>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Default View">Default View</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">STAGE</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Default View">ALL</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">AWAITNG SUPPORT REPLY</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Default View">All</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">SUPPORT CASE</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="Default View">Default View</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Box
                sx={{
                  backgroundColor: "#bbd9e8",
                  p: 1,
                }}
              >
                <Stack spacing={2} direction="row">
                  <Button className="blue-button">New Case</Button>
                  <Button className="blue-button">Attach</Button>
                  <Button className="blue-button">Customize View</Button>
                </Stack>
              </Box>
                <AgGridPaginatedTable
                  // getTableRows={getTransactionShippingAddressData}
                  columns={invoiceSupportCasesTable}
                  refreshCounter={0}
                />
                </Box>
              </TabPanel>
              <TabPanel value={tabIndexRelatedRecord} index={3}>
                <AgGridPaginatedTable
                  // getTableRows={getTransactionShippingAddressData}
                  columns={purchaseOrderRelatedRecordTransformation}
                  refreshCounter={0}
                />
              </TabPanel>
              
            </Box>
          </TabPanel>
          {/*------------System Information ------------*/}
          <TabPanel value={tabIndex} index={5}>
            {tabIndex === 5 && <PurchaseOrderSystemInformation />}
          </TabPanel>
          {/*------------Custom ------------*/}
          <TabPanel value={tabIndex} index={6}>
          {tabIndex === 6 &&    <PurchaseOrderCustom />}
          </TabPanel>
        
          {/*------------EFT-----------*/}
          <TabPanel value={tabIndex} index={7}>
          {tabIndex === 7 &&     <PurchaseOrderEft/>}
          </TabPanel>
          {/*------------J.P.Morgan-----------*/}
          <TabPanel value={tabIndex} index={8}>
            <Box className="viewDetilsBox">
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P. MORGAN REFERENCE ID</p>
                  <p className="tFormName"></p>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.R. MORGAN STATUS</p>
                  <p className="tFormName"></p>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.R. MORGAN MESSAGE</p>
                  <p className="tFormName"></p>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.P. MORGAN UPDATED DATE</p>
                  <p className="tFormName"></p>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.R. MORGAN PAYER</p>
                  <p className="tFormName"></p>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">J.R. MORGAN TRANSACTION ID</p>
                  <p className="tFormName"></p>
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
